import React, { useMemo, useState } from "react";
import Tabs from "@/wmCompoments/tabs";
import TabsButton from "@/wmCompoments/tabs/TabsButton";
import styles from '../styles/messageHeader.module.scss'
import { useGetUnreadForType } from "../hooks/useMessageCenter";
import { useMessageContext } from "../context";
import EditMessage from "./editMessage";
import { useTranslation } from "react-i18next";

const MessageHeader = () => {
  const { t } = useTranslation('messageCenter')

  const [mainTabsIndex, setMainTabsIndex] = useState(0) // 菜单项管理
  const [subTabsIndex, setSubTabsIndex] = useState(0) // Tabs项管理
  // 获取当前上下文中的通用数据和方法
  const { selectedItem, setSelectedItem, setEditor, setSelectedIds } = useMessageContext();
  // 获取站内信未读数
  const { data } =useGetUnreadForType()
  const counts = useMemo(() => {
    const {
      brnotice_count = 0,
      bractivity_count = 0,
      brmatch_count = 0,
      brfd_count = 0,
      notice_count = 0,
      activity_count = 0,
      fd_count = 0
    } = data || {};
    return {
      brnotice_count,
      bractivity_count,
      brmatch_count,
      brfd_count,
      notice_count,
      activity_count,
      fd_count
    };
  }, [data]);
  // 菜单项
  const mainTabs = useMemo(()=>{
    const total1 = counts.brnotice_count + counts.bractivity_count + counts.brmatch_count + counts.brfd_count
    const total2 = counts.notice_count + counts.activity_count + counts.fd_count
    return[
      { 
        title: t('messageCenter'),
        number: total1 > 99 ? '99+' : total1
      },
      { 
        title: t('privateNotice'),
        number: total2 > 99 ? '99+' : total2
      },
    ]
  },[counts])
  // 消息中心Tabs项
  const subTabs1 = useMemo(()=>{
    return [
      { 
        title: t('notice'),
        number: counts.brnotice_count > 99 ? '99+' : counts.brnotice_count,
        brType: 1,
        msgType: 1,
      },
      { 
        title: t('activity'),
        number: counts.bractivity_count > 99 ? '99+' : counts.bractivity_count,
        brType: 1,
        msgType: 2,
      },
      { 
        title: t('announcement'),
        number: 0,
        brType: 1,
        msgType: 3,
      },
      { 
        title: t('matchAnnouncement'),
        number: counts.brmatch_count > 99 ? '99+' : counts.brmatch_count,
        brType: 1,
        msgType: 4,
      },
      { 
        title: t('depositWithdraw'),
        number: counts.brfd_count > 99 ? '99+' : counts.brfd_count,
        brType: 1,
        msgType: 5,
      },
    ]
  },[counts])
  // 私信通知Tabs项
  const subTabs2 = useMemo(()=>{
    return [
      { 
        title: t('notice'),
        number: counts.notice_count > 99 ? '99+' : counts.notice_count,
        brType: 2,
        msgType: 1,
      },
      { 
        title: t('activity'),
        number: counts.activity_count > 99 ? '99+' : counts.activity_count,
        brType: 2,
        msgType: 2,
      },
      { 
        title: t('depositWithdraw'),
        number: counts.fd_count > 99 ? '99+' : counts.fd_count,
        brType: 2,
        msgType: 5,
      },
    ]
  },[counts])

  const subTabs = useMemo(() => {
    return mainTabsIndex === 0 ? subTabs1 : subTabs2
  }, [mainTabsIndex, subTabs1, subTabs2])

  // 点击菜单项 传递菜单项下面tabs项中第一项的通用数据(后续请求渲染列表)
  const handleMainTabChange = (index) => {
    setMainTabsIndex(index);
    setSubTabsIndex(0);
    setEditor(false);         // 退出编辑模式
    setSelectedIds([]);       // 清空选中项
    const firstTab = index === 0 ? subTabs1[0] : subTabs2[0];
    setSelectedItem?.({
      brType: firstTab.brType,
      msgType: firstTab.msgType
    });
  };
  // 点击tabs项 传递当前项的通用数据(后续请求渲染列表)
  const handleSubTabChange = (index) => {
    const numberIndex = Number(index);
    setSubTabsIndex(numberIndex);
    // setSubTabsIndex(index);
    const item = subTabs[numberIndex];
    setEditor(false);         // 退出编辑模式
    setSelectedIds([]);       // 清空选中项
    setSelectedItem?.({
      brType: item.brType,
      msgType: item.msgType
    });
  };

  return(
    <div>
      <div className={styles.top}>
        <div className={styles.buttons}>
          {mainTabs.map((v,index)=>{
            return(
              <div key={index} 
                onClick={()=> {
                  handleMainTabChange(index)
                }}
                className={`${styles.button} ${index === mainTabsIndex ? styles.active : ''}`}
              >
                <div>{v.title}</div>
                {!!v.number && <div className={styles.number}>{v.number}</div>}
              </div>
            )
          })}
        </div>

        {/* 编辑 */}
        {selectedItem?.msgType !== 3 && <EditMessage />}
      </div>
      
      <div className={styles.tabs}>
        <Tabs type={'line'}
          onClickTab={(key) => {
            handleSubTabChange(key)
          }}
          activeTab={subTabsIndex?.toString()}
          >
          {
            subTabs?.map((v, index) => {
              return <TabsButton key={index} className={styles.item}>
                <div>{v.title}</div>
                {!!v.number && <div className={styles.number}>{v.number}</div>}
              </TabsButton>
            })
          }
        </Tabs>
      </div>
      
    </div>
  )
}

export default MessageHeader